export const SERVICES_BASE_URL = process.env.VUE_APP_SERVICES_RHOMTRIP;
export const WEBSITE_BASE_URL = process.env.VUE_APP_RHOMTRIP;
export const IMAGE_BASE_URL = process.env.VUE_APP_IMAGE_URL;

export const API_BASE_URL = `${SERVICES_BASE_URL}/api/v1.0`;
export const PUBLIC_API_BASE_URL = `${SERVICES_BASE_URL}/api/public`;

export const BYTESCALE_API_URL = process.env.VUE_APP_BYTESCALE_API_URL;
export const BYTESCALE_ACCOUNT_ID = process.env.VUE_APP_BYTESCALE_ACCOUNT_ID;
export const BYTESCALE_API_SECRET_KEY = process.env.VUE_APP_BYTESCALE_API_SECRET_KEY;
export const BYTESCALE_API_PUBLIC_KEY = process.env.VUE_APP_BYTESCALE_API_PUBLIC_KEY;

export const EXCHANGERATE_API_URL = process.env.VUE_APP_EXCHANGERATE_API_URL;
export const EXCHANGERATE_API_KEY = process.env.VUE_APP_EXCHANGERATE_API_KEY;

export const ENV = process.env.VUE_APP_ENV;